import * as THREE from "three";
import {TransformControls} from "three/examples/jsm/controls/TransformControls.js"


function ClipeModel(scene, camera, renderer, model,orbitcontrols) {
    this._init_(scene, camera, renderer, model,orbitcontrols)
}
ClipeModel.prototype = {
    constructor: ClipeModel,
    _init_: function (scene, camera, renderer, model,orbitcontrols) {
        this.scene = scene;
        this.camera = camera;
        this.renderer = renderer;
        this.model = model;
        this.orbitcontrols=orbitcontrols;
        this.showAxis=true;
        this.clipedTop=false;
        this.clipedFront=false;
        this.clipedRight=false;
    },
    clipingTop: function () {
        this.clipedTop=true;
        let plane = new THREE.Plane(new THREE.Vector3(0, -1, 0), 0);
        this.planeHelper_top = new THREE.PlaneHelper(plane, 1, 0xffffff);
        this.planeHelper_top.visible = true;
        this.scene.add(this.planeHelper_top);
        this.setClipMaterial(this.model,plane)
        const geometry = new THREE.BoxBufferGeometry(0, 0, 0);
        const material = new THREE.MeshLambertMaterial({ transparent: true });
        this.controlHelper_top = new THREE.Mesh(geometry, material);
        this.scene.add(this.controlHelper_top);

        this.control_top = new TransformControls(this.camera, this.renderer.domElement);
        this.control_top.addEventListener('change', () => {
            plane.constant = this.controlHelper_top.position.y;
        });
        this.control_top.addEventListener('dragging-changed', (event) => {
            this.orbitcontrols.enabled = !event.value;
        });
        this.control_top.showX = false;
        this.control_top.showY = this.showAxis;
        this.control_top.showZ = false;
        this.control_top.attach(this.controlHelper_top);
        this.scene.add(this.control_top);
        // this.initClip(plane);
    },
    clipingFront: function () {
        this.clipedFront=true;
        let plane_front = new THREE.Plane(new THREE.Vector3(-1, 0, 0), 0.8);
        this.planeHelper_front = new THREE.PlaneHelper(plane_front, 1, 0xffffff);
        this.planeHelper_front.visible = true;
        this.scene.add(this.planeHelper_front);
        this.setClipMaterial(this.model,plane_front)
        const geometry_front = new THREE.BoxBufferGeometry(2, 0, 0);
        const material_front = new THREE.MeshLambertMaterial({ transparent: true });
        this.controlHelper_front = new THREE.Mesh(geometry_front, material_front);
        this.scene.add(this.controlHelper_front);

        this.control_front = new TransformControls(this.camera, this.renderer.domElement);
        this.control_front.addEventListener('change', () => {
            plane_front.constant = this.controlHelper_front.position.x;
        });
        this.control_front.addEventListener('dragging-changed', (event) => {
            this.orbitcontrols.enabled = !event.value;
        });
        this.control_front.showX = this.showAxis;
        this.control_front.showY = false;
        this.control_front.showZ = false;
        this.control_front.attach(this.controlHelper_front);
        this.scene.add(this.control_front);
        // this.initClip(plane);
    },
    clipingRight: function () {
        this.clipedRight=true;
        let plane_right = new THREE.Plane(new THREE.Vector3(0, 0, -1), 0.8);
        this.planeHelper_right = new THREE.PlaneHelper(plane_right, 1, 0xffffff);
        this.planeHelper_right.visible = true;
        this.scene.add(this.planeHelper_right);
        this.setClipMaterial(this.model,plane_right)
        const geometry_right = new THREE.BoxBufferGeometry(0, 0, 2);
        const material_right = new THREE.MeshLambertMaterial({ transparent: true });
        this.controlHelper_right = new THREE.Mesh(geometry_right, material_right);
        this.scene.add(this.controlHelper_right);

        this.control_right = new TransformControls(this.camera, this.renderer.domElement);
        this.control_right.addEventListener('change', () => {
            plane_right.constant = this.controlHelper_right.position.z;
        });
        this.control_right.addEventListener('dragging-changed', (event) => {
            this.orbitcontrols.enabled = !event.value;
        });
        this.control_right.showX = false;
        this.control_right.showY = false;
        this.control_right.showZ = this.showAxis;
        this.control_right.attach(this.controlHelper_right);
        this.scene.add(this.control_right);
        // this.initClip(plane);
    },
    dontShowAxis:function(value){
        if(this.clipedTop){
            this.control_top.showY=!value;
        }
        if(this.clipedFront){
            this.control_front.showX=!value;
        }
        if(this.clipedRight){
            this.control_right.showZ=!value;
        }
    },
    closeClipingTop: function () {
        this.clipedTop=false;
        this.clearClipMaterial(this.model,1);
        this.scene.remove(this.control_top);
        this.scene.remove(this.controlHelper_top);
        this.scene.remove(this.planeHelper_top);
    },
    closeClipingFront: function () {
        this.clipedFront=false;
        this.clearClipMaterial(this.model,0);
        this.scene.remove(this.control_front);
        this.scene.remove(this.controlHelper_front);
        this.scene.remove(this.planeHelper_front);
    },
    closeClipingRight: function () {
        this.clipedRight=false;
        this.clearClipMaterial(this.model,2);
        this.scene.remove(this.control_right);
        this.scene.remove(this.controlHelper_right);
        this.scene.remove(this.planeHelper_right);
    },

    resetAll:function(){
        this.clearClipMaterial(this.model,-1);
        this.clipedTop=false;
        this.clipedFront=false;
        this.clipedRight=false;
        this.scene.remove(this.control_top);
        this.scene.remove(this.controlHelper_top);
        this.scene.remove(this.planeHelper_top);
        this.scene.remove(this.control_front);
        this.scene.remove(this.controlHelper_front);
        this.scene.remove(this.planeHelper_front);
        this.scene.remove(this.control_right);
        this.scene.remove(this.controlHelper_right);
        this.scene.remove(this.planeHelper_right);
    },

    createPlaneStencilGroup: function (geometry, plane, renderOrder) {

        const group = new THREE.Group();
        const baseMat = new THREE.MeshBasicMaterial();
        baseMat.depthWrite = false;
        baseMat.depthTest = false;
        baseMat.colorWrite = false;
        baseMat.stencilWrite = true;
        baseMat.stencilFunc = THREE.AlwaysStencilFunc;

        // back faces
        const mat0 = baseMat.clone();
        mat0.side = THREE.BackSide;
        mat0.clippingPlanes = [plane];
        mat0.stencilFail = THREE.IncrementWrapStencilOp;
        mat0.stencilZFail = THREE.IncrementWrapStencilOp;
        mat0.stencilZPass = THREE.IncrementWrapStencilOp;

        const mesh0 = new THREE.Mesh(geometry, mat0);
        mesh0.renderOrder = renderOrder;
        group.add(mesh0);

        // front faces
        const mat1 = baseMat.clone();
        mat1.side = THREE.FrontSide;
        mat1.clippingPlanes = [plane];
        mat1.stencilFail = THREE.DecrementWrapStencilOp;
        mat1.stencilZFail = THREE.DecrementWrapStencilOp;
        mat1.stencilZPass = THREE.DecrementWrapStencilOp;
        const mesh1 = new THREE.Mesh(geometry, mat1);
        mesh1.renderOrder = renderOrder;
        group.add(mesh1);
        return group;
    },

    //把所有的模型的材质改成可裁剪材质
    setClipMaterial: function (object,plane) {
        let index;
        object.children.forEach((child) => {
            if (child.isMesh) {
                if (child.material.length) {
                    child.material.forEach((mat) => {
                        if(!mat.clippingPlanes){
                            mat.clippingPlanes=[];
                        }
                        mat.clippingPlanes.push(plane);
                        index=mat.clippingPlanes.length-1;
                        mat.clipShadows = true;
                    });
                } else {
                    if(!child.material.clippingPlanes){
                        child.material.clippingPlanes=[];
                    }
                    child.material.clippingPlanes.push(plane);
                    child.material.clipShadows = true;
                }
            }else if(child.isGroup){
                this.setClipMaterial(child,plane);
            }
        });
        return index;
    },
    clearClipMaterial: function (object,index){
        object.children.forEach((child) => {
            if (child.isMesh) {
                let newPlanes=[];
                if (child.material.length) {
                    child.material.forEach((mat) => {
                        if(mat.clippingPlanes)
                        for (let i = 0; i < mat.clippingPlanes.length; i++) {
                            switch(index){
                                case 0:
                                    if(mat.clippingPlanes[i].normal.x!==-1){
                                        newPlanes.push(mat.clippingPlanes[i])
                                    }
                                    break;
                                case 1:
                                    if(mat.clippingPlanes[i].normal.y!==-1){
                                        newPlanes.push(mat.clippingPlanes[i])
                                    }
                                    break;
                                case 2:
                                    if(mat.clippingPlanes[i].normal.z!==-1){
                                        newPlanes.push(mat.clippingPlanes[i])
                                    }
                                    break;
                                case -1:
                                    newPlanes=[];
                                    break;
                            }
                        }
                        mat.clippingPlanes=newPlanes;
                    });
                } else {
                    if(child.material.clippingPlanes)
                    for (let i = 0; i < child.material.clippingPlanes.length; i++) {
                        switch(index){
                            case 0:
                                if(child.material.clippingPlanes[i].normal.x!==-1){
                                    newPlanes.push(child.material.clippingPlanes[i])
                                }
                                break;
                            case 1:
                                if(child.material.clippingPlanes[i].normal.y!==-1){
                                    newPlanes.push(child.material.clippingPlanes[i])
                                }
                                break;
                            case 2:
                                if(child.material.clippingPlanes[i].normal.z!==-1){
                                    newPlanes.push(child.material.clippingPlanes[i])
                                }
                                break;
                            case -1:
                                newPlanes=[];
                                break;
                        }
                    }
                    child.material.clippingPlanes=newPlanes;

                }
            }else if(child.isGroup){
                switch(index){
                    case 0:
                        this.clearClipMaterial(child,0);
                        break;
                    case 1:
                        this.clearClipMaterial(child,1);
                        break;
                    case 2:
                        this.clearClipMaterial(child,2);
                        break;
                    case -1:
                        this.clearClipMaterial(child,-1);
                        break;
                }
            }
        });
    }
}

export {
    ClipeModel
}